import { FooterContent, ClearFilterButton, ShowTripButton } from './style.js';
import texts from './FilterFooter.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useIsMobile from '../../../hooks/useIsMobile.js';
import useGlobals from '../../../hooks/useGlobals.js';

var FilterFooter = function FilterFooter(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    onClearFilter = _ref.onClearFilter,
    onShowTrip = _ref.onShowTrip,
    _ref$disableClearFilt = _ref.disableClearFilter,
    disableClearFilter = _ref$disableClearFilt === void 0 ? false : _ref$disableClearFilt;
  var isMobile = useIsMobile();
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var clearFiltersLabel = texts[culture].clearFilters;
  var showTripLabel = texts[culture].showTrip;
  return /*#__PURE__*/jsxs(FooterContent, {
    className: className,
    children: [/*#__PURE__*/jsx(ClearFilterButton, {
      variant: isMobile ? 'secondary' : 'ghost',
      onClick: function onClick() {
        return onClearFilter();
      },
      disabled: disableClearFilter,
      children: clearFiltersLabel
    }), /*#__PURE__*/jsx(ShowTripButton, {
      variant: "primary",
      onClick: function onClick() {
        return onShowTrip();
      },
      children: showTripLabel
    })]
  });
};
var FilterFooter$1 = FilterFooter;

export { FilterFooter$1 as default };
//# sourceMappingURL=FilterFooter.js.map
